<template>
  <section class="communication">
    <!-- Header -->
    <leftMenu />
    <dotLoader v-if="this.isLoading"></dotLoader>

    <page-header
      @tabSelectedChanged="myAction"
      icon="newspaper-outline"
      :totalTabs="tabsAnnoucements"
      :headerProps="this.headerProps"
    />
    <annoucements-cards :annoucements="annoucementsFiltered" :isLoading="this.isLoading"/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import PageHeader from '../../components/layouts/pageHeader.vue';
  import AnnoucementsCards from '../../components/layouts/annoucementsCards.vue';
  import dotLoader from '../../components/dotLoader.vue';
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import { GET_ALL_ANNOUCEMENTS } from "../../../../urlConfig"

  export default {
    name: 'communication',
    components: {
      leftMenu,
      PageHeader,
      AnnoucementsCards,
      dotLoader
    },
    data() {
      return {
      isLoading: false,
      isDarkModeActive: false,
      annoucements: [],
      readLength: 0,
      unreadLength: 0,
      allAnnoucementsLength: 0,
      allAnnoucements: [],
      tabsAnnoucements: [],
      tabSelected: '',
      annoucementsFiltered: [],
      annoucementsRead: [],
      annoucementsUnread: [],
      headerProps: {
        filterOrDate: 'filter',
        headerTitle: this.$t('Comunicados'),
        }
      }
    },
    methods: {
      getAllNotices() {
        this.isLoading = true;
        const url = GET_ALL_ANNOUCEMENTS + "?pageQtd=20&pageNumber=1&device=web"

        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console(response);
          this.annoucements = response.data;
          this.allAnnoucements = this.annoucements.result.list

          this.filterAnnoucements();
          this.sortByUrgency(this.allAnnoucements)
          this.isLoading = false;
        })
        .catch(reason => {
          console.log("deu erro");
        });
      },
      filterAnnoucements() {
        this.allAnnoucementsLength = this.allAnnoucements.length;
        this.readLength = this.allAnnoucements.filter((e) => e.readAt !== null).length;
        this.unreadLength = this.allAnnoucements.filter((e) => e.readAt === null).length;

        this.annoucementsRead = this.allAnnoucements.filter((e) => e.readAt !== null);
        this.annoucementsUnread = this.allAnnoucements.filter((e) => e.readAt === null);
        this.annoucementsFiltered = this.allAnnoucements;

        this.tabsAnnoucements = [
          {
            name: `Todos (${this.allAnnoucementsLength})`
          },
          {
            name: `Lidos (${this.readLength})`
          },
          {
            name: `Não lidos (${this.unreadLength})`
          }
        ]
      },
      sortByUrgency(array) {
            return array.sort(function (a, b) {
                return b.companyStatementType - a.companyStatementType
            });
      },
      myAction(value) {
        this.tabSelected = value
      },
    },
    beforeMount() {
      this.getAllNotices();
    },
    watch: {
      tabSelected(newValue) {
        if(newValue === 1) {
          this.annoucementsFiltered = this.allAnnoucements
        } else if (newValue === 2){
          this.annoucementsFiltered = this.sortByUrgency(this.annoucementsRead)
        } else {
          this.annoucementsFiltered = this.sortByUrgency(this.annoucementsUnread)
        }
      }
    },
    computed: {
      currentRouteName() {
        return this.$route.path;
      }
    },
  }
</script>

<!-- Style from page -->
<style lang="scss">
  .communication {
    transition: 0.5s;
    background: var(--bodyColor2);
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/communication/communication.vue